// extracted by mini-css-extract-plugin
module.exports = {"wrap":"VkHeader_wrap__3RyfN","back":"VkHeader_back__32W3-"};